export const API_BASE = import.meta.env.VITE_API_BASE || 'http://localhost:8081';

export const config = {
  apiBase: API_BASE,
  appName: 'BONG · AI',
  version: '0.0.0',
  canvas: {
    minZoom: 0.1,
    maxZoom: 3,
    defaultZoom: 1,
  },
  node: {
    defaultWidth: 280,
    defaultHeight: 200,
  },
};

export default config;